import type { Footer } from '@hub/models/api/page-content.types';
import * as Sentry from '@sentry/nextjs';
import { OBLIGATORY_FOOTER_FIELDS } from './constants';
import { Logger } from '@icommerce/logger';

export const isCorrectFooterObject = (footerJson: Footer): boolean => {
  const footerJsonKeys = Object.keys(footerJson);
  const missingAttributes: string[] = OBLIGATORY_FOOTER_FIELDS.filter(field => !footerJsonKeys.includes(field));

  if (!missingAttributes.length) {
    return true;
  }
  Logger.warn(
    { message: `The following attributes was missing in the footer object: ${missingAttributes.join(', ')}` },
    'FooterMissingAttributes'
  );

  Sentry.captureException(
    new Error(`The following attributes was missing in the footer object: ${missingAttributes.join(', ')}`)
  );

  return false;
};
